import { Header, HeaderTitle, pageEntranceSpringValues } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { animated, useSpring } from 'react-spring'

import { Proposal } from '../../../../../../domain'
import { useFormValidation } from '../../../../../../hooks/adjustments/formValidation'
import {
  useProposalAdjustment,
  useProposalFormData,
} from '../../../../../../hooks/adjustments/proposal'
import {
  TExtends,
  TKey,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'
import { MainDisclosureConfig } from '../../../../../../state/configuration'
import { FormErrors } from '../../../../../formBuilder'

export interface DisclosureFormProps {
  section: MainDisclosureConfig
  isLastSection: boolean
  onComplete: (proposal: Proposal) => void
}

const tKey = TKey('pages.disclosure')

export const DisclosureSection: FunctionComponent<DisclosureFormProps> = ({
  section,
  isLastSection,
  onComplete,
}) => {
  const { t } = useWriskTranslation()
  const spring = useSpring(pageEntranceSpringValues)

  const data = useProposalFormData(section.form)

  const onSubmitAdjustment = useProposalAdjustment({
    form: section.form,
    applyRating: isLastSection,
    onComplete: onComplete,
  })

  const onValidateForm = useFormValidation({
    validationProfile: section.validationProfile,
    onSuccess: onSubmitAdjustment.execute,
  })

  return (
    <animated.div style={spring}>
      <Header>
        <HeaderTitle>{t(tKey('headers', section.id))}</HeaderTitle>
      </Header>
      <FormErrors
        id={section.id}
        key={section.id}
        footerText={section.footerText}
        data={data}
        config={section.form}
        onSubmit={onValidateForm.execute}
        loading={onValidateForm.loading}
        tKey={TExtends(tKey, 'form')}
        t={t}
      />
    </animated.div>
  )
}
